import React from 'react';
import './collaborations-main.scss';
const marked = require('marked');

export default ({ data }) =>
    <div className="main">
        <div className="main__content">
            <div className="main__content__still">
                <a target="_blank" href={data.mainUrl}>
                    <img src={data.mainImage.file.url} />
                </a>
            </div>
            <div className="main__content__copy">
                <h1 className="main__content__headline">
                    {data.mainHeading}
                    <br />
                    {data.mainHeadingLineTwo}
                </h1>
                <div
                    className="main__content__copy__inner"
                    dangerouslySetInnerHTML={{
                        __html: marked(data.mainText.mainText, {
                            gfm: true,
                            breaks: true,
                        }),
                    }}
                />
                <div className="collaborations__link">
                    <a target="_blank" href={data.mainUrl}>
                        {data.mainCallToActionText}
                        <i className="fas fa-chevron-right" />
                    </a>
                </div>
            </div>
        </div>
    </div>;



// WEBPACK FOOTER //
// ./src/components/collaborations-main.js